<div class="content dark">
	<div *ngIf="rotor" class="row">
		<label class="col-md-2 col-form-label">Operation:</label>
		<div class="col-md-4">
			<select *ngIf="operations !== undefined" class="form-control form-control-sm op-list" [(ngModel)]="operation" (ngModelChange)="refreshRegimeCounts()"
				title="Only showing {{ operations && operations.length >= 800 ? 'latest 800 ' : '' }}operations with track data for rotor '{{rotor.rotorid}}'">
				<option *ngFor="let operation of operations" [ngValue]="operation" [ngClass]="{ 'has-ex': operation.exceedance_count > 0 }">
					{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
					runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}{{operation.exceedance_count > 0 ? "
						Ex: " + operation.exceedance_count : ""}}
				</option>
			</select>
			<select *ngIf="operations === undefined" class="form-control form-control-sm" disabled>
				<option>Loading Track operations...</option>
			</select>
		</div>
	</div>
	<div *ngIf="regimeCounts !== undefined && regimeCounts.length === 0" style="padding: 50px;">
		No track data is available for the selected operation
	</div>
	<div *ngIf="regimeCounts !== undefined && regimeCounts.length > 0" class="row">
		<div class="col-lg-5">
			<div class="item-panel">
				<div class="heading">Regimes</div>
				<div class="content">
					<table class="table regimes">
						<tr>
							<th># Acq</th>
							<th>Regime</th>
							<th>Eval</th>
							<th>Split</th>
							<th>Pred</th>
						</tr>
						<tr *ngFor="let regime of regimeCounts">
							<td>{{regime.count}}</td>
							<td>{{regime.name}}</td>
							<td class="center"><input type="checkbox" [(ngModel)]="regime.evaluate" (ngModelChange)="regimesChange()"></td>
							<td><span *ngIf="regimeSplit">{{regimeSplit[regime.regime_id]?.split | number : "1.1-1"}}</span></td>
							<td><span *ngIf="regimeSplit">{{regimeSplit[regime.regime_id]?.predsplit | number : "1.1-1"}}</span></td>
						</tr>
					</table>
				</div>
			</div>
			<div *ngIf="rotor.balancedata && rotor.balancedata.numblades >= 4 && !rotor.balancedata.oneperrev" class="row">
				<div class="col-sm-4">
					1/rev Only
				</div>
				<div class="col-sm-8">
					<div class="form-check form-check-inline">
						<label class="form-check-label">
							<input type="checkbox" [(ngModel)]="onePerRevOnly" (ngModelChange)="updatePlot()">
						</label>
					</div>
				</div>
			</div>
			<div *ngIf="selectedRegimes && selectedRegimes.length" class="item-panel">
				<div class="heading">Adjustments</div>
				<div class="content">
					<table class="table adjustments">
						<tr>
							<th></th>
							<!-- Note: configs with extra blades in displaygroups are "guaranteed" to not use track -->
							<th *ngFor="let blade of ReorderBlades(rotor.blade)">{{blade.name}}</th>
							<th></th>
						</tr>
						<ng-container *ngFor="let adjdef of rotor.adjdef; let i = index">
							<!-- Hardcoded exclude 'WTS' adjdef for track -->
							<ng-container *ngIf="adjdef.name !== 'WTS'">
								<tr>
									<th>
										<a [hidden]="!alternates || !alternates[i].length" (click)="adjDetail[i] = !adjDetail[i]" href="javascript:void(0)" class="nowrap">{{ adjdef.name }} &#9662;</a>
										<span [hidden]="alternates && alternates[i].length">{{ adjdef.name }}:</span>
									</th>
									<td *ngFor="let blade of rotor.blade; let j = index">
										<input *ngIf="adjustments" [(ngModel)]="adjustments[i][j]" (keyup.enter)="ManualAdjustment()" type="number" class="adj-entry">
									</td>
									<th class="adjust-check">
										<input [(ngModel)]="adjustmentSelect[i]" class="form-check-input" type="checkbox" (ngModelChange)="updatePlot()">
									</th>
								</tr>
								<ng-container *ngIf="alternates">
									<tr *ngFor="let alt of alternates[i]; let altIdx = index" (click)="SetAdjustment(i, altIdx)" [hidden]="!adjDetail[i]" class="alt-row">
										<th></th>
										<td *ngFor="let blade of rotor.blade; let j = index">
											<div *ngIf="adjustments">{{alt[j] | number : "1.0-1"}}</div>
										</td>
										<th></th>
									</tr>
								</ng-container>
								<tr class="divider">
									<th></th>
								</tr>
							</ng-container>
						</ng-container>
					</table>
					<button (click)="RecordAdjustment()" class="btn btn-primary btn-sm form-control">Record adjustment</button>
				</div>
			</div>
		</div>
		<div class="col-lg-7">
			<div class="item-panel">
				<div class="heading">Blade track</div>
				<div class="content">
					<app-dvs-chart [error]="errormessage" [options]="trackOptions" [light]="true" [height]="'400px'"></app-dvs-chart>
					<div *ngIf="trackOptions" class="legend">
						<span class="legend-item">
							<span class="swatch" style="background-color: #027A85"></span> Averages
						</span>
						<span class="legend-item">
							<span class="swatch" style="background-color: #DBCD00"></span> Predictions
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="operations && operations.length === 0" class="pt-4 pb-5">
		No operations with track data are available
	</div>
	<div *ngIf="operations && operations.length > 0 && regimeCounts === undefined" class="text-center pt-3 pb-3">
		<div class="logo-spin light"></div>
		Loading track operations...
	</div>
</div>